import type { ReceiptTemplate } from '../schema';

export const enterpriseTemplate: ReceiptTemplate = {
  id: 'enterprise',
  name: 'Enterprise Receipt',
  brand: 'ENTERPRISE',
  description: 'Enterprise Rent-A-Car receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ent-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'ENTERPRISE',
        businessNameFontSize: 18,
        addressLines: ['RENT-A-CAR', '1200 DARK AVENUE', 'MONSTERVILLE, CA 94608', '(510) 555-0127'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ent-rental',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'renter', label: 'Renter:', value: 'JOHN DOE' },
          { id: 'vehicle', label: 'Vehicle:', value: 'TOYOTA CAMRY' },
        ],
        column2: [
          { id: 'pickup', label: 'Pick-Up:', value: '01/02/2026' },
          { id: 'return', label: 'Return:', value: '01/05/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ent-charges',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'daily', label: 'DAILY RATE x 3', value: '147.00', isBold: false, isLarge: false },
          { id: 'insurance', label: 'INSURANCE', value: '45.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '17.28', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '209.28', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ent-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'ent-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: "WE'LL PICK YOU UP\n\nTHANK YOU", fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

